export const formatPercent = (val, decimals = 2) =>
  val != null ? `${Number(val).toFixed(decimals)}%` : 'N/A';

export const formatNumber = (val) =>
  val != null ? Number(val).toLocaleString() : 'N/A';

export const formatMs = (val) => {
  if (val == null) return 'N/A';
  if (val >= 1000) return `${(val / 1000).toFixed(1)}s`;
  return `${Math.round(val)}ms`;
};

export const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleDateString('en-IN', {
    day: 'numeric', month: 'short', year: 'numeric',
  });
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return 'N/A';
  return new Date(dateStr).toLocaleString('en-IN', {
    day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit',
  });
};

export const getHealthColor = (score) => {
  if (score >= 80) return 'text-emerald-400';
  if (score >= 50) return 'text-amber-400';
  return 'text-red-400';
};

export const getHealthBg = (score) => {
  if (score >= 80) return 'bg-emerald-500/15 border-emerald-500/20';
  if (score >= 50) return 'bg-amber-500/15 border-amber-500/20';
  return 'bg-red-500/15 border-red-500/20';
};

export const getReadinessConfig = (readiness) => {
  const configs = {
    green: { label: 'Ready', color: 'text-emerald-400', bg: 'bg-emerald-500/15', dot: 'status-dot-green' },
    yellow: { label: 'Caution', color: 'text-amber-400', bg: 'bg-amber-500/15', dot: 'status-dot-yellow' },
    red: { label: 'Blocked', color: 'text-red-400', bg: 'bg-red-500/15', dot: 'status-dot-red' },
  };
  return configs[readiness] || configs.yellow;
};

export const getTrendArrow = (current, previous) => {
  if (!current || !previous) return { arrow: '', color: 'text-gray-400' };
  const diff = current - previous;
  if (Math.abs(diff) < 0.01) return { arrow: '~', color: 'text-gray-400', change: 0 };
  if (diff > 0) return { arrow: '\u2191', color: 'text-emerald-400', change: diff };
  return { arrow: '\u2193', color: 'text-red-400', change: diff };
};

// --- Release Risk Score utilities ---

export const getRiskStatusConfig = (status) => {
  const configs = {
    stable:   { label: 'Stable',   color: 'text-emerald-400', bg: 'bg-emerald-500/15', border: 'border-emerald-500/30', dot: 'bg-emerald-400' },
    monitor:  { label: 'Monitor',  color: 'text-amber-400',   bg: 'bg-amber-500/15',   border: 'border-amber-500/30',   dot: 'bg-amber-400' },
    risk:     { label: 'Risk',     color: 'text-orange-400',  bg: 'bg-orange-500/15',  border: 'border-orange-500/30',  dot: 'bg-orange-400' },
    critical: { label: 'Critical', color: 'text-red-400',     bg: 'bg-red-500/15',     border: 'border-red-500/30',     dot: 'bg-red-400' },
  };
  return configs[status] || configs.critical;
};

export const getDeploymentConfig = (recommendation) => {
  const configs = {
    continue: { label: 'Continue Rollout', color: 'text-emerald-400', bg: 'bg-emerald-500/15', border: 'border-emerald-500/30', icon: 'check-circle' },
    pause:    { label: 'Pause Rollout',    color: 'text-amber-400',   bg: 'bg-amber-500/15',   border: 'border-amber-500/30',   icon: 'pause-circle' },
    rollback: { label: 'Rollback',         color: 'text-red-400',     bg: 'bg-red-500/15',     border: 'border-red-500/30',     icon: 'x-circle' },
  };
  return configs[recommendation] || configs.pause;
};

export const formatReleaseDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  const d = new Date(dateStr);
  const now = new Date();
  const diffMs = now - d;
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  const formatted = d.toLocaleDateString('en-IN', {
    day: '2-digit', month: 'short', year: 'numeric',
  });

  if (diffDays === 0) return `${formatted} (today)`;
  if (diffDays === 1) return `${formatted} (1d ago)`;
  if (diffDays < 30) return `${formatted} (${diffDays}d ago)`;
  if (diffDays < 365) return `${formatted} (${Math.floor(diffDays / 30)}mo ago)`;
  return formatted;
};

/**
 * Format version string to match Firebase/Google Play Console format.
 * e.g., "1.0.9 (154)" where 1.0.9 = app_version, 154 = version_code/build number
 */
export const formatVersion = (appVersion, versionCode) => {
  if (!appVersion) return 'N/A';
  const ver = String(appVersion).replace(/^v/, '');
  if (versionCode) return `${ver} (${versionCode})`;
  return ver;
};

export const getRiskScoreColor = (score) => {
  if (score >= 90) return 'text-emerald-400';
  if (score >= 75) return 'text-amber-400';
  if (score >= 60) return 'text-orange-400';
  return 'text-red-400';
};
